angular
    .module('dnecom.component.desktopTimer', ['ngCookies']);
